module.exports = __webpack_public_path__ + "assets/tiktok-pixel.cc375635.svg";